export const featuresTranslations = {
    en: {
        title: 'Effortlessly Elegant Invoicing',
        subtitle: 'Send invoices instantly. No fees. Just beautiful simplicity.',
        features: [
            {
                title: 'Instant Creation – No onboarding flow',
                description: 'No forms. No logins. No friction. Just start typing, and your invoice is ready in seconds.'
            },
            {
                title: 'Support for All Payment Methods',
                description: 'Credit cards (Visa, Mastercard), Apple Pay, iDeal, Klarna, Sepa, PayPal and more - we\'ve got you covered.'
            },
            {
                title: 'Effortless Recurring Invoices',
                description: 'Set up recurring invoices once and let the system handle the rest. Perfect for subscriptions and regular clients.'
            },
            {
                title: '1-Click Cloud Login',
                description: 'Sign in with your favorite provider and access your invoices from anywhere. Your data is always secure.'
            },
            {
                title: 'Apple-Inspired Design',
                description: 'Sleek, distraction-free, and intuitive interface that puts your content first.'
            }
        ]
    },
    nl: {
        title: 'Moeiteloos Elegant Factureren',
        subtitle: 'Verstuur facturen direct. Geen kosten. Gewoon prachtige eenvoud.',
        features: [
            {
                title: 'Directe Creatie – Geen onboarding',
                description: 'Geen formulieren. Geen logins. Geen wrijving. Begin gewoon met typen en je factuur is binnen enkele seconden klaar.'
            },
            {
                title: 'Ondersteuning voor Alle Betaalmethoden',
                description: 'Creditcards (Visa, Mastercard), Apple Pay, iDeal, Klarna, Sepa, PayPal en meer - wij hebben alles voor je geregeld.'
            },
            {
                title: 'Moeiteloze Terugkerende Facturen',
                description: 'Stel eenmalig terugkerende facturen in en laat het systeem de rest afhandelen. Perfect voor abonnementen en vaste klanten.'
            },
            {
                title: '1-Klik Cloud Login',
                description: 'Log in met je favoriete provider en krijg overal toegang tot je facturen. Je gegevens zijn altijd veilig.'
            },
            {
                title: 'Apple-Geïnspireerd Ontwerp',
                description: 'Strak, afleidingsvrij en intuïtief interface dat je content voorop stelt.'
            }
        ]
    }
}; 